import React from "react";
import DonutChart from "../../../../Universal/DonutChart.component";
import CardHeader from "../../../../Universal/CardHeader.component";
import SelectFilter from "../../../UniversalComponents/SelectFilter.component";
import ScrollableCardTable from "../../../../Universal/ScrollableCardTable.component";

const CashOutFlowPieChartOne = ({ donutChartData }) => {
  console.log(donutChartData);

  return (
    <div style={{ padding: "1rem", marginBottom:"1rem" }} className="viewPollingDetailsContainer">
      <CardHeader
        title="Marketing expenses"
        actionBtn={<SelectFilter />}
        headerStyle={{ borderBottom: "none" }}
      />
      <div className="flex-row g-05 space-between w-full h-half flex-1">
        <div className="h-full w-half">
          <DonutChart
            data={donutChartData}
            title="Total expenses in market"
            valuemapKey="percentage"
          />
        </div>

        <div className="w-half h-full flex-col align-start justify-start">
          <ScrollableCardTable thead={["Categories", "Contribution(%)"]}>
            {donutChartData &&
              donutChartData.map((_data, index) => {
                return (
                  <tr
                    style={{
                      "--pollingDonutChartTableDetailsIndicatorColor":
                        _data.positionColor,
                    }}
                    className="pollingDetailsTableData w-full flex-row align-center justify-arround"
                  >
                    <td
                      style={{
                        width: `calc(100%/${3})`,
                        textAlign: "center",
                      }}
                    >
                      {_data.category}
                    </td>
                    {/* <td
                      style={{
                        width: `calc(100%/${3})`,
                        textAlign: "center",
                      }}
                    >
                      {_data.appearanceCount}
                    </td> */}
                    <td
                      style={{
                        width: `calc(100%/${3})`,
                        textAlign: "center",
                      }}
                    >
                      {_data.percentage} %
                    </td>
                  </tr>
                );
              })}
          </ScrollableCardTable>
        </div>
      </div>
    </div>
  );
};

export default CashOutFlowPieChartOne;
